import * as types from './types';
import { success, loading, error } from 'State/actions';

export const getItems = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_MAINTENANCE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'INVItem/GetItems',
        {
          ItemId: id ? id : null,
          ItemGroupFilterId: null,
          BidGroupFilterId: null,
          AccountCategoryFilterId: null,
          VendorFilterId: null,
          BidPriceFilter: null,
          ActiveStatus: null,
        }
      );
      dispatch(success(types.ITEM_MAINTENANCE_LISTING, response));
    } catch (ex) {
      dispatch(error(types.ITEM_MAINTENANCE_LISTING_ERROR, ex));
    } finally {
      dispatch(loading(types.ITEM_MAINTENANCE_LOADING, false));
    }
  };
};

export const clearItemGridData = () => {
  return {
    type: types.ITEM_MAINTENANCE_CLEAR_ITEMS_GRID,
  };
};

export const deleteItem = Id => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.postGenericDelete('INVItem', Id);
      dispatch({
        type: types.ITEM_MAINTENANCE_DELETE,
        payload: response.data,
      });
    } catch (ex) {
      dispatch(error(types.ITEM_MAINTENANCE_DELETE_ERROR, ex));
      throw ex;
    } finally {
      dispatch(loading(types.ITEM_MAINTENANCE_LOADING, false));
    }
  };
};

export const clearItemMaintenanceErrors = () => {
  return {
    type: types.ITEM_MAINTENANCE_CLEAR_ERRORS,
  };
};

export const updateSelectedRowIndex = index => {
  return dispatch =>
    dispatch({
      type: types.UPDATE_SELECTED_BID_ROW_INDEX,
      payload: index,
    });
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/itemMaintenance/actions.js